module.exports = __webpack_public_path__ + "img/ad.ff86d8f3.png";